/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IReferenceNode } from '../IReferenceNode';
import { SecurityScheme } from './SecurityScheme';
import { IDefinition } from './IDefinition';
import { OAuthFlows } from './OAuthFlows';

/**
 * Constructor.
 * @param {string} schemeName
 * @class
 * @extends SecurityScheme
 * @author eric.wittmann@gmail.com
 */
export abstract class ModernSecurityScheme extends SecurityScheme implements IReferenceNode, IDefinition {
    public $ref : string;

    public scheme : string;

    public bearerFormat : string;

    public flows : OAuthFlows;

    public openIdConnectUrl : string;

    public constructor(schemeName : string) {
        super(schemeName);
        if(this.$ref===undefined) this.$ref = null;
        if(this.scheme===undefined) this.scheme = null;
        if(this.bearerFormat===undefined) this.bearerFormat = null;
        if(this.flows===undefined) this.flows = null;
        if(this.openIdConnectUrl===undefined) this.openIdConnectUrl = null;
    }

    /**
     * 
     * @return {string}
     */
    public getReference() : string {
        return this.$ref;
    }

    /**
     * 
     * @param {string} reference
     */
    public setReference(reference : string) {
        this.$ref = reference;
    }

    public abstract createOAuthFlows() : OAuthFlows;
}
ModernSecurityScheme["__class"] = "io.apicurio.datamodels.core.models.common.ModernSecurityScheme";
ModernSecurityScheme["__interfaces"] = ["io.apicurio.datamodels.core.models.common.IDefinition","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];




